module.exports = __webpack_public_path__ + "static/media/view3.49e1f3c2.jpg";